import { API_ROUTES } from '../constants';
import apiClient from './apiClient';

const authService = {
  login: async (credentials) => {
    try {
      const response = await apiClient.post(API_ROUTES.LOGIN, credentials);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Login failed';
      throw new Error(errorMessage);
    }
  },

  register: async (data) => {
    try {
      const { confirmPassword, ...payload } = data;
      const response = await apiClient.post(API_ROUTES.REGISTER, payload);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Registration failed';
      throw new Error(errorMessage);
    }
  },
};

export default authService;
